<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="login-icon">
          <i class="el-icon-s-custom"></i>
        </div>
        <h1>365n 供应链管理中心</h1>
        <p>分身持有者登录入口</p>
      </div>
      <el-form ref="loginForm" :model="form" :rules="rules" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入账号" prefix-icon="el-icon-user" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-btn" :loading="loading" @click="handleLogin">立即登录</el-button>
        </el-form-item>
      </el-form>
      <div class="login-footer">
        <span>&copy; 2026 365n 供应链管理中心 版权所有</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('login', {
            username: this.form.username,
            password: this.form.password
          }).then(() => {
            return this.$store.dispatch('fetchUserInfo')
          }).then(() => {
            // 落地页取「第一个有权限的菜单」，不能固定跳 /dashboard：
            // 角色权限里没有勾选「首页数据」时，直接跳首页等于绕过了权限
            this.$router.push(this.$store.getters.firstAccessiblePath || '/403')
            this.$message.success('登录成功')
          }).catch(() => {
            // 错误信息已在 API 拦截器中提示
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
}
.login-card {
  width: 420px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.login-header {
  padding: 40px 32px 0;
  text-align: center;
}
.login-icon {
  width: 64px;
  height: 64px;
  background: #3a8ee6;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(228, 57, 60, 0.4);
}
.login-header h1 {
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 8px;
}
.login-header p {
  font-size: 13px;
  color: #909399;
  margin: 0 0 32px;
}
.login-form {
  padding: 0 32px;
}
.login-btn {
  width: 100%;
  background: #3a8ee6;
  border-color: #3a8ee6;
}
.login-btn:hover {
  background: #c91b1d;
  border-color: #c91b1d;
}
.login-footer {
  padding: 16px 32px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
  text-align: center;
  font-size: 12px;
  color: #c0c4cc;
}
</style>
